// src/components/AccountCreation/AccountCreation.js
import React, { useState } from 'react';
import { PLANS_CONFIG } from './constants';
import Stepper from './Stepper';
import Step1_SubscriptionPlan from './Step1_SubscriptionPlan';
import Step2_UserDetails from './Step2_UserDetails';
import Step3_PaymentDetails from './Step3_PaymentDetails';
import Step4_Confirmation from './Step4_Confirmation';
import Step5_Status from './Step5_Status';

const AccountCreation = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isProcessing, setIsProcessing] = useState(false);
  const [status, setStatus] = useState('');

  const getInitialData = () => {
    const region = Object.keys(PLANS_CONFIG)[0];
    const deviceType = Object.keys(PLANS_CONFIG[region])[0];
    const plan = Object.keys(PLANS_CONFIG[region][deviceType])[0];
    const frequency = Object.keys(PLANS_CONFIG[region][deviceType][plan])[0];
    return {
      subscription: { region, deviceType, plan, frequency },
      user: { email: '', firstName: '', lastName: '', dob: '', address: '', username: '', password: '' },
      payment: { cardName: '', cardNumber: '', expiryDate: '', cvv: '', billingAddress: '' },
    };
  };

  const [formData, setFormData] = useState(getInitialData());

  const nextStep = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    } else if (currentStep === 4) {
      setIsProcessing(true);
      setTimeout(() => {
        const isSuccess = Math.random() > 0.2;
        setStatus(isSuccess ? 'success' : 'failure');
        setCurrentStep(5);
        setIsProcessing(false);
      }, 2000);
    }
  };
  
  const resetWorkflow = () => { 
    setFormData(getInitialData()); 
    setCurrentStep(1); 
    setStatus(''); 
  };

  const renderStep = () => {
    const props = {
        data: formData,
        setData: setFormData,
        nextStep: nextStep,
    };
    switch (currentStep) {
      case 1: return <Step1_SubscriptionPlan {...props} />;
      case 2: return <Step2_UserDetails {...props} />;
      case 3: return <Step3_PaymentDetails {...props} />;
      case 4: return <Step4_Confirmation {...props} />;
      case 5: return <Step5_Status status={status} reset={resetWorkflow} />;
      default: return <Step1_SubscriptionPlan {...props} />;
    }
  };
  
  const steps = ["Plan", "Details", "Payment", "Confirm"];

  return (
    <>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" />
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css" />
      <style>{`
        :root {
          --bs-primary: #0B5798;
          --bs-primary-rgb: 11, 87, 152;
        }
        .btn-primary {
            --bs-btn-color: #fff;
            --bs-btn-bg: #0B5798;
            --bs-btn-border-color: #0B5798;
            --bs-btn-hover-color: #fff;
            --bs-btn-hover-bg: #0a4a80;
            --bs-btn-hover-border-color: #094373;
            --bs-btn-focus-shadow-rgb: 49, 132, 253;
            --bs-btn-active-color: #fff;
            --bs-btn-active-bg: #094373;
            --bs-btn-active-border-color: #083c66;
            --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
            --bs-btn-disabled-color: #fff;
            --bs-btn-disabled-bg: #0B5798;
            --bs-btn-disabled-border-color: #0B5798;
        }
        .stepper-wrapper { display: flex; justify-content: space-between; margin-bottom: 2.5rem; }
        .stepper-item { position: relative; display: flex; flex-direction: column; align-items: center; flex: 1; }
        .stepper-item::before { position: absolute; content: ""; border-bottom: 2px solid #ccc; width: 100%; top: 20px; left: -50%; z-index: 2; }
        .stepper-item::after { position: absolute; content: ""; border-bottom: 2px solid #ccc; width: 100%; top: 20px; left: 50%; z-index: 2; }
        .stepper-item .step-counter { position: relative; z-index: 5; display: flex; justify-content: center; align-items: center; width: 40px; height: 40px; border-radius: 50%; background: #ccc; margin-bottom: 6px; font-weight: bold; color: #fff; }
        .stepper-item.active .step-counter { background-color: var(--bs-primary); }
        .stepper-item.completed .step-counter { background-color: var(--bs-success); font-size: 1.25rem; }
        .stepper-item.completed .step-name { color: #6c757d; }
        .stepper-item.completed::after { position: absolute; content: ""; border-bottom: 2px solid var(--bs-success); width: 100%; top: 20px; left: 50%; z-index: 3; }
        .stepper-item:first-child::before { content: none; }
        .stepper-item:last-child::after { content: none; }
      `}</style>
      <div className="bg-light min-vh-100 d-flex flex-column justify-content-center align-items-center p-3 p-md-4">
        <div className="col-12 col-lg-8 col-xl-7">
          <div className="card shadow-lg border-0" style={{position: 'relative'}}>
            {isProcessing && (<div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75 rounded" style={{zIndex: 10}}><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>)}
            <div className="card-body p-4 p-md-5">
              {currentStep <= steps.length && ( <Stepper currentStep={currentStep} steps={steps} /> )}
              {renderStep()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountCreation;
